export default __webpack_public_path__ + "static/media/test-image.eb79ffe6.jpg";